import { Component, OnInit } from '@angular/core';
import { Actionbutton } from './../../shared/common/Actionbutton';
import { MatSnackBar } from "@angular/material/snack-bar";
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { constants } from './../../shared/common/contants';

@Component({
    selector: 'app-plans-cofiguration',
    templateUrl: './plans-cofiguration.component.html',
    styleUrls: ['./plans-cofiguration.component.scss'],
    standalone: false
})
export class PlansCofigurationComponent implements OnInit {
  backgroundColorButton = "";
  backgroundColorScreen="";
  buttonColor="";
  allocateButtonsBoolean = false;
  bootstrapColumn: any;
  allocateButtons1Boolean = false;
  closeIconButton1Boolean = false;
  closeIconButtonBoolean = false;
  components: any;
  columnDefsForPlans;
  columnDefsForFeatures;
  defaultColDef;
  Features = [];
  plans = [];
  features:any = [];
  rowData: any;
  rowDataForPlans: any;
  selectedFeatures = [];
  gridApi: any;
  columnApi: any;
  rowSelectionForPlans;
  rowSelection;
  eveIndex: any;
  rowSelectionForFeatures;
  temp: any = [];

  
  constructor(private snackbar: MatSnackBar, private localStorageSettings: LocalStorageSettingsService,private constants: constants) { 
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  ngOnInit() {

    this.columnDefsForPlans = [
      {
        headerName: "Plans",
        headerTooltip: "Plans",
        tooltipValueGetter: params => "Plans : " + params.value,
        field: "plan",
        filter: "agTextColumnFilter",
        width: 300,
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForFeatures = [
      {
        headerName: "Features",
        headerTooltip: "Features",
        tooltipValueGetter: params => "Features : " + params.value,
        field: "feature",
        filter: "agTextColumnFilter",
        width: 800,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px", 'pointer-events': 'none' }
      }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForFeatures='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    this.plans = [
      { id: '1', plan: "plan1" },
      { id: '2', plan: "plan2" },
      { id: '3', plan: "plan3" },
      { id: '4', plan: "plan4" }
    ];

    this.features = [
      { id: '1', feature: "feature1" },
      { id: '1', feature: "feature2" },
      { id: '1', feature: "feature3" },
      { id: '1', feature: "feature4" },
      { id: '2', feature: "feature5" },
      { id: '2', feature: "feature6" },
      { id: '2', feature: "feature7" },
      { id: '2', feature: "feature8" },
      { id: '3', feature: "feature9" },
      { id: '3', feature: "feature10" },
      { id: '3', feature: "feature11" },
      { id: '3', feature: "feature12" },
      { id: '4', feature: "feature13" },
      { id: '4', feature: "feature14" },
      { id: '4', feature: "feature15" },
      { id: '4', feature: "feature16" }
    ];

    console.log(this.features);
    this.rowData = this.features;
    this.rowDataForPlans = this.plans;
  }

  cellClickedPlan(event){
    this.Features = [];
    this.selectedFeatures=[];
    this.gridApi.api.deselectAll();
    console.log(event.data.id);
    console.log(this.features);
    for (let i = 0; i < this.features.length; i++) {
      this.gridApi.api.forEachNode(node=> {
        if(event.data.id===node.data.id){
          node.setSelected(true);  
          this.Features = node.data.feature;
          console.log(this.Features);    
        }        
      });
      this.selectedFeatures = this.Features;
      console.log(this.selectedFeatures);
    }
  }

  async onGridReadyForPlans(params){

  }

  async onGridReadyForFeatures(params){
    this.gridApi= params;
    this.columnApi = params.columnApi;
  }

  onRowSelected(event) {

    // this.Features = this.gridApi.api.getSelectedRows();
    // console.log(this.Features);

    // this.selectedFeatures = this.Features;

    // console.log(this.selectedFeatures);
  }

  save(){
    if(this.selectedFeatures.length === 0){
      this.snackbar.open("Please select Plan.", "OK", {
        duration: 5000,
      });
    }
    else{
      this.snackbar.open("Features added successfully.", "OK", {
        duration: 5000,
      });
      console.log(this.selectedFeatures);
      console.log("Success");
      // this.gridApi.api.deselectAll();
      this.selectedFeatures = [];
    }
  }

}
